import EnvironmentSettings from "../../Models/EnvironmentSettings";
import TenantManager from "../TenantManager";
import UsersApi from "../UsersApi";

class AppointmentsApi {
  constructor() {
    EnvironmentSettings.Environment === "dev"
      ? (this.baseUrl = EnvironmentSettings.LocalUrl)
      : (this.baseUrl = EnvironmentSettings.LiveUrl);
  }

  // Appointment Requests
  CreatePatientAppointmentRequestUrl = "Appointments/CreatePateintAppointmentRequest";
  SearchPatientAppointmentsUrl = "Appointments/SearchAllPatientAppointments";

  async SearchPatientAppointments(req) {
    let url = this.baseUrl + this.SearchPatientAppointmentsUrl;
    let res = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + UsersApi.GetToken(),
        tenant: TenantManager.getTenant(UsersApi.GetToken()),
      },
      body: JSON.stringify(req),
    });
    let data = await res.json();
    return data;
  }

  async CreatePatientAppointmentRequest(req) {
    let url = this.baseUrl + this.CreatePatientAppointmentRequestUrl;
    let response = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + UsersApi.GetToken(),
        tenant: TenantManager.getTenant(UsersApi.GetToken()),
      },
      body: JSON.stringify(req),
    });
    let data = await response.json();
    console.log(data);
    return data;
  }

  // Appointments NEW AND IMPROVED AND OPTIMIZED

  LinkAccountingSessionToAppointmentHourUrl = "Appointments/LinkAccountingSessionToAppointmentHour";
  ClearAppiontmentHourAccountingSessionsUrl = "Appointments/ClearAppiontmentHourAccountingSessions";
  ClearAccountingSessionAppointmentHourUrl = "Appointments/ClearAccountingSessionAppointmentHour";
  GetAppointmentDayByIdSimplifiedUrl = "Appointments/GetAppointmentDayByIdSimplified";
  GetAppoinmentDayByIdIndexedUrl = "Appointments/GetAppointmentDayByIdIndexed";
  GetAppointmentDayHoursByHoursUrl = "Appointments/GetAppointmentDayHoursByHour";
  RefreshSessionsRemainingUrl = "Appointments/RefreshSessionsRemaining";

  async LinkAccountingSessionToAppointmentHour(req) {
    let url = this.baseUrl + this.LinkAccountingSessionToAppointmentHourUrl;
    let response = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + UsersApi.GetToken(),
        tenant: TenantManager.getTenant(UsersApi.GetToken()),
      },
      body: JSON.stringify(req),
    });
    let data = await response.json();
    console.log(data);
    return data;
  }

  //RefreshSessionsRemaining
  async RefreshSessionsRemaining(req) {
    let url = this.baseUrl + this.RefreshSessionsRemainingUrl;
    let response = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + UsersApi.GetToken(),
        tenant: TenantManager.getTenant(UsersApi.GetToken()),
      },
      body: JSON.stringify(req),
    });
    let data = await response.json();
    console.log(data);
    return data;
  }

  async ClearAppiontmentHourAccountingSessions(req) {
    let url = this.baseUrl + this.ClearAppiontmentHourAccountingSessionsUrl;
    let response = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + UsersApi.GetToken(),
        tenant: TenantManager.getTenant(UsersApi.GetToken()),
      },
      body: JSON.stringify(req),
    });
    let data = await response.json();
    console.log(data);
    return data;
  }

  async ClearAccountingSessionAppointmentHour(req) {
    let url = this.baseUrl + this.ClearAccountingSessionAppointmentHourUrl;
    let response = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + UsersApi.GetToken(),
        tenant: TenantManager.getTenant(UsersApi.GetToken()),
      },
      body: JSON.stringify(req),
    });
    let data = await response.json();
    console.log(data);
    return data;
  }

  async GetAppointmentDayByIdSimplified(req) {
    let url = this.baseUrl + this.GetAppointmentDayByIdSimplifiedUrl;
    let response = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + UsersApi.GetToken(),
        tenant: TenantManager.getTenant(UsersApi.GetToken()),
      },
      body: JSON.stringify(req),
    });
    let data = await response.json();
    console.log(data);
    return data;
  }

  async GetAppointmentDayHoursByHours(req) {
    let url = this.baseUrl + this.GetAppointmentDayHoursByHoursUrl;
    let response = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + UsersApi.GetToken(),
        tenant: TenantManager.getTenant(UsersApi.GetToken()),
      },
      body: JSON.stringify(req),
    });
    let data = await response.json();
    console.log(data);
    return data;
  }

  async GetAppoinmentDayByIdIndexed(req) {
    let url = this.baseUrl + this.GetAppoinmentDayByIdIndexedUrl;
    let response = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + UsersApi.GetToken(),
        tenant: TenantManager.getTenant(UsersApi.GetToken()),
      },
      body: JSON.stringify(req),
    });
    let data = await response.json();
    console.log(data);
    return data;
  }
  //******************Appointments*****************************************/
  ToggleHideSuggestionUrl = "Appointments/ToggleHideSuggestion";
  GetPatientSuggestionsUrl = "Appointments/GetPatientSuggestions";
  GetSimilarSessionUrl = "Appointments/GetSimilarSession";
  CopyAppointmentDayUrl = "Appointments/CopyAppointmentDay";
  ClearAppointmentDayUrl = "Appointments/ClearAppointmentDay";
  ConfirmAppointmentUrl = "Appointments/ConfirmAppointment";
  CreateAppointmentWithHoursUrl = "Appointments/CreateAppointmentWithHours";
  GetAppoinmentDayByDateUrl = "Appointments/GetAppointmentDayByDate";
  GetAppoinmentDayByIdUrl = "Appointments/GetAppointmentDayById";
  AddTherapistToAppointmentDayUrl = "Appointments/AddTherapistToAppointmentDay";
  ClearAccountingSessionAppointmentHourUrl = "Appointments/ClearAccountingSessionAppointmentHour";
  GetAppoinmentHourByIdUrl = "Appointments/GetAppointmentHourById";
  ExportAppointmentDayUrl = "Appointments/ExportAppointmentDay";
  ExportAccountingDayUrl = "Appointments/ExportAccountingDay";
  GetDayRemindersUrl = "Appointments/GetDayReminders";
  ResetCountSinceLastEvalUrl = "Appointments/ResetCountSinceLastEval";
  SetLastEvalReminderUrl = "Appointments/SetLastEvalReminder";

  async SetLastEvalReminder(req) {
    let url = this.baseUrl + this.SetLastEvalReminderUrl;
    let response = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + UsersApi.GetToken(),
        tenant: TenantManager.getTenant(UsersApi.GetToken()),
      },
      body: JSON.stringify(req),
    });
    let data = await response.json();
    return data;
  }
  async ResetCountSinceLastEval(req) {
    let url = this.baseUrl + this.ResetCountSinceLastEvalUrl;
    let response = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + UsersApi.GetToken(),
        tenant: TenantManager.getTenant(UsersApi.GetToken()),
      },
      body: JSON.stringify(req),
    });
    let data = await response.json();
    return data;
  }

  async GetDayReminders(req) {
    let url = this.baseUrl + this.GetDayRemindersUrl;
    let response = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + UsersApi.GetToken(),
        tenant: TenantManager.getTenant(UsersApi.GetToken()),
      },
      body: JSON.stringify(req),
    });
    let data = await response.json();
    return data;
  }

  async ToggleHideSuggestion(req) {
    let url = this.baseUrl + this.ToggleHideSuggestionUrl;
    let response = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + UsersApi.GetToken(),
        tenant: TenantManager.getTenant(UsersApi.GetToken()),
      },
      body: JSON.stringify(req),
    });
    let data = await response.json();
    console.log(data);
    return data;
  }
  async GetPatientSuggestions(req) {
    let url = this.baseUrl + this.GetPatientSuggestionsUrl;
    let response = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + UsersApi.GetToken(),
        tenant: TenantManager.getTenant(UsersApi.GetToken()),
      },
      body: JSON.stringify(req),
    });
    let data = await response.json();
    return data;
  }
  async GetSimilarSession(req) {
    let url = this.baseUrl + this.GetSimilarSessionUrl;
    let response = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + UsersApi.GetToken(),
        tenant: TenantManager.getTenant(UsersApi.GetToken()),
      },
      body: JSON.stringify(req),
    });
    let data = await response.json();
    console.log(data);
    return data;
  }
  async CopyAppointmentDay(req) {
    let url = this.baseUrl + this.CopyAppointmentDayUrl;
    let response = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + UsersApi.GetToken(),
        tenant: TenantManager.getTenant(UsersApi.GetToken()),
      },
      body: JSON.stringify(req),
    });
    let data = await response.json();
    console.log(data);
    return data;
  }
  async ClearAppointmentDay(req) {
    let url = this.baseUrl + this.ClearAppointmentDayUrl;
    let response = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + UsersApi.GetToken(),
        tenant: TenantManager.getTenant(UsersApi.GetToken()),
      },
      body: JSON.stringify(req),
    });
    let data = await response.json();
    console.log(data);
    return data;
  }
  async ExportAccountingDay(req) {
    let url = this.baseUrl + this.ExportAccountingDayUrl;
    let response = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + UsersApi.GetToken(),
        tenant: TenantManager.getTenant(UsersApi.GetToken()),
      },
      body: JSON.stringify(req),
    });
    let data = await response.blob();
    console.log(data);
    return data;
  }
  async ExportAppointmentDay(req) {
    let url = this.baseUrl + this.ExportAppointmentDayUrl;
    let response = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + UsersApi.GetToken(),
        tenant: TenantManager.getTenant(UsersApi.GetToken()),
      },
      body: JSON.stringify(req),
    });
    let data = await response.blob();
    console.log(data);
    return data;
  }
  async ClearAccountingSessionAppointmentHour(req) {
    let url = this.baseUrl + this.ClearAccountingSessionAppointmentHourUrl;
    let response = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + UsersApi.GetToken(),
        tenant: TenantManager.getTenant(UsersApi.GetToken()),
      },
      body: JSON.stringify(req),
    });
    let data = await response.json();
    console.log(data);
    return data;
  }

  async ConfirmAppointment(req) {
    let url = this.baseUrl + this.ConfirmAppointmentUrl;
    let response = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + UsersApi.GetToken(),
        tenant: TenantManager.getTenant(UsersApi.GetToken()),
      },
      body: JSON.stringify(req),
    });
    let data = await response.json();
    console.log(data);
    return data;
  }

  async CreateAppointmentWithHours(req) {
    let url = this.baseUrl + this.CreateAppointmentWithHoursUrl;
    let response = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + UsersApi.GetToken(),
        tenant: TenantManager.getTenant(UsersApi.GetToken()),
      },
      body: JSON.stringify(req),
    });
    let data = await response.json();
    console.log(data);
    return data;
  }

  async GetAppoinmentDayByDate(req) {
    console.log(req);
    let url = this.baseUrl + this.GetAppoinmentDayByDateUrl;
    let response = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + UsersApi.GetToken(),
        tenant: TenantManager.getTenant(UsersApi.GetToken()),
      },
      body: JSON.stringify(req),
    });
    let data = await response.json();
    console.log(data);
    return data;
  }

  async GetAppoinmentDayById(req) {
    let url = this.baseUrl + this.GetAppoinmentDayByIdUrl;
    let response = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + UsersApi.GetToken(),
        tenant: TenantManager.getTenant(UsersApi.GetToken()),
      },
      body: JSON.stringify(req),
    });
    let data = await response.json();
    console.log(data);
    return data;
  }

  async AddTherapistToAppointmentDay(req) {
    let url = this.baseUrl + this.AddTherapistToAppointmentDayUrl;
    let response = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + UsersApi.GetToken(),
        tenant: TenantManager.getTenant(UsersApi.GetToken()),
      },
      body: JSON.stringify(req),
    });
    let data = await response.json();
    console.log(data);
    return data;
  }

  async GetAppoinmentHourById(req) {
    let url = this.baseUrl + this.GetAppoinmentHourByIdUrl;
    let response = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + UsersApi.GetToken(),
        tenant: TenantManager.getTenant(UsersApi.GetToken()),
      },
      body: JSON.stringify(req),
    });
    let data = await response.json();
    console.log(data);
    return data;
  }

  // Patient Programs

  CreatePatientProgramUrl = "Appointments/CreatePatientProgram";
  SearchPatientProgramsUrl = "Appointments/SearchPatientPrograms";
  GetPatientProgramByIdUrl = "Appointments/GetPatientProgram";
  ApplyPatientProgramUrl = "Appointments/ApplyPatientProgram";
  RemovePatientAppointmentsUrl = "Appointments/RemovePatientAppointments";
  async CreatePatientProgram(req) {
    let url = this.baseUrl + this.CreatePatientProgramUrl;
    let response = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + UsersApi.GetToken(),
        tenant: TenantManager.getTenant(UsersApi.GetToken()),
      },
      body: JSON.stringify(req),
    });
    let data = await response.json();
    console.log(data);
    return data;
  }

  async SearchPatientPrograms(req) {
    let url = this.baseUrl + this.SearchPatientProgramsUrl;
    let response = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + UsersApi.GetToken(),
        tenant: TenantManager.getTenant(UsersApi.GetToken()),
      },
      body: JSON.stringify(req),
    });
    let data = await response.json();
    console.log(data);
    return data;
  }

  async GetPatientProgramById(req) {
    let url = this.baseUrl + this.GetPatientProgramByIdUrl;
    let response = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + UsersApi.GetToken(),
        tenant: TenantManager.getTenant(UsersApi.GetToken()),
      },
      body: JSON.stringify(req),
    });
    let data = await response.json();
    console.log(data);
    return data;
  }

  async GetPatientProgramById(req) {
    let url = this.baseUrl + this.GetPatientProgramByIdUrl;
    let response = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + UsersApi.GetToken(),
        tenant: TenantManager.getTenant(UsersApi.GetToken()),
      },
      body: JSON.stringify(req),
    });
    let data = await response.json();
    console.log(data);
    return data;
  }

  async ApplyPatientProgram(req) {
    let url = this.baseUrl + this.ApplyPatientProgramUrl;
    let response = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + UsersApi.GetToken(),
        tenant: TenantManager.getTenant(UsersApi.GetToken()),
      },
      body: JSON.stringify(req),
    });
    let data = await response.json();
    console.log(data);
    return data;
  }

  async RemovePatientAppointments(req) {
    let url = this.baseUrl + this.RemovePatientAppointmentsUrl;
    let response = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + UsersApi.GetToken(),
        tenant: TenantManager.getTenant(UsersApi.GetToken()),
      },
      body: JSON.stringify(req),
    });
    let data = await response.json();
    console.log(data);
    return data;
  }
}

export default new AppointmentsApi();
